import { ILocation } from '@models/interfaces/ILocation';
import { DcasLocationFormatter } from '../dcas-location-formatter/dcas-location-formatter';

export class FusLocationFormatter extends DcasLocationFormatter {
  format(location: ILocation): string[] {
    const locationLines: string[] = super.format(location);

    const jsonMiscData = this.parseMiscData(location.LocationMiscData);
    const entryPoint: string = this.renderAccessPoint(location, jsonMiscData['Entree']);
    const exitPoint: string = this.renderAccessPoint(location, jsonMiscData['Sortie']);

    locationLines.push(...[entryPoint, exitPoint].filter(s => s));

    return locationLines;
  }

  private renderAccessPoint(location: ILocation, jsonMiscData): string {
    return jsonMiscData
      ? [this.renderFields(['SFULLTEXT', 'REFNODES_SNAME'], location, jsonMiscData), this.getKmPoint(jsonMiscData)]
          .filter(s => s)
          .join(', ')
      : '';
  }
}
